import { CheckCircle, XCircle } from 'phosphor-react'
import { type ToastOptions } from 'react-toastify'

export const TOAST_SUCCESS_DEFAULT_OPTIONS: ToastOptions = {
  position: 'top-right',
  autoClose: 3000,
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: true,
  closeButton: false,
  className: 'bg-green-50',
  icon: (
    <CheckCircle size={48} className="mx-auto my-auto text-alert-success" />
  ),
}

export const TOAST_ERROR_DEFAULT_OPTIONS: ToastOptions = {
  position: 'top-right',
  autoClose: 3000,
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: true,
  closeButton: false,
  icon: <XCircle size={48} className="mx-auto my-auto text-alert-error" />,
  className: 'bg-red-50',
}
